<ng-container *ngIf="noRegistrations">
    <div class="empty-page">
        <mat-icon>warning</mat-icon>
        <h2>{{ 'registration.list.none_found' | translate }}</h2>
    </div>
</ng-container>

<ng-container *ngIf="noRegistrationSets">
    <div class="empty-page">
        <mat-icon>warning</mat-icon>
        <h2>{{ 'registration.list.none_regSet_found' | translate }}</h2>
    </div>
</ng-container>

<ng-container *ngIf="loading">
    <div class="empty-page">
        <mat-spinner diameter="60"></mat-spinner>
        <h2>{{ 'registration.loading' | translate }}...</h2>
    </div>
</ng-container>
